export default {
  retrievedPersons: (state, persons) => {
    state.persons = persons;
  },
  pageOptions: (state, options) => {
    state.options = options;
  },
  pageFilters: (state, filters) => {
    state.filters = filters;
  }
};
